"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defer = exports.createCompanyContentUrl = exports.canSubmit = void 0;

var _assert = _interopRequireDefault(require("assert"));

var _util = _interopRequireDefault(require("util"));

var _querystring = _interopRequireDefault(require("querystring"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var canSubmit = function canSubmit(initialValues, values, errors) {
  try {
    _assert["default"].deepStrictEqual(initialValues, values);

    return false;
  } catch (_unused) {
    return !Boolean(Object.keys(errors).length);
  }
};

exports.canSubmit = canSubmit;

var createCompanyContentUrl = function createCompanyContentUrl(companyId, key, signed) {
  var host = process.env.REACT_APP_CONTENT_HOST.replace(/\/$/, '');
  var versionKey = signed.versionKey,
      signature = signed.signature,
      keyPairId = signed.keyPairId,
      policy = signed.policy,
      cfSignature = signed.cfSignature,
      cfPolicy = signed.cfPolicy,
      cfKeyPairId = signed.cfKeyPairId;

  var qs = _querystring["default"].stringify({
    v: versionKey || 0,
    Signature: signature || cfSignature,
    'Key-Pair-Id': keyPairId || cfKeyPairId,
    Policy: policy || cfPolicy
  });

  return _util["default"].format('%s/%d/%s?%s', host, companyId, key, qs);
};
/**
 * Defer action to next animation frame. This is helpful
 * when button effect stuttering because of the UI thread
 * immediately being utilized
 */


exports.createCompanyContentUrl = createCompanyContentUrl;

var defer = function defer(promise) {
  return new Promise(function (resolve, reject) {
    requestAnimationFrame(function () {
      return Promise.resolve().then(function () {
        return promise();
      }).then(function (r) {
        return resolve(r);
      })["catch"](function (e) {
        return reject(e);
      });
    });
  });
};

exports.defer = defer;